import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { fr } from 'vuetify/locale'
import { App, getRouter, vuetifyOptions, type IConfiguration } from '@fondationcss/ui';
import { getCustomRoutes } from './routes';
import { sidebarItems } from './sidebar-items';
import { WikiPlugin } from '@fondationcss/wiki'

import 'vuetify/styles';
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';
import '@fondationcss/ui/dist/style.css';
import '@fondationcss/wiki/dist/style.css';
import '@fondationcss/markdown/dist/style.css';
import '@fondationcss/markdown/dist/markdown.css';
import "@/styles.css";
import 'highlight.js/styles/github.css';

import Logo from '@/svg/kwiz.svg';
import LogoWhite from '@/svg/kwiz-white.svg';

const config = {
  AppName: 'Kwiz',
  SiteNameShort: 'Kwiz',
  SiteNameLong: 'Kwiz - Plateforme de quiz interactif',
  LogoLine1: 'Kwiz',
  LogoLine2: 'Quiz interactif en temps réel',
  Copyright: 'Copyright © 2026',
  SidebarItems: sidebarItems,

  DefaultLayout: 'byrnu-red-app',
  ThemeColor: '#3460a8',

  EnableAccessRequestButton: false,
  Logo: Logo,  // Generic logo fallback (URL)
  // SiteLogo: '/images/test-logo.svg'  // Logo for login/init screens (URL)
  // SiteLogoSvg: '<svg>...</svg>'  // Logo for login/init screens (raw SVG - takes priority over SiteLogo and Logo)
  SiteLogoAlt: LogoWhite,  // Logo for header (URL)
  // SiteLogoAltSvg: '<svg>...</svg>'  // Logo for header (raw SVG - takes priority over all others)
  // HideLoginLogo: true,  // Uncomment to hide the bottom logo on login page
} as IConfiguration;

const vuetify = createVuetify({
    components,
    directives,
    ...vuetifyOptions
  })
const app = createApp(App);
const router = getRouter(getCustomRoutes);
app.provide('config', config)
app.provide('sdkOptions', { apiUrl: import.meta.env.VITE_API_URL || (import.meta.env.DEV ? 'https://localhost:11443/api' : undefined) })
app.use(vuetify);
app.component('font-awesome-icon', FontAwesomeIcon)
library.add(fas)
library.add(far)
app.use(createPinia());
app.use(PerfectScrollbarPlugin);
app.use(router);
// Type assertion needed due to Vue 3.5+ stricter Plugin generic constraints
app.use(WikiPlugin as any, { router })
app.mount('#app');
